<template>
  <div class="form-group">
    <label class="control-label blue">{{ label }}</label
    ><br />
    <date-picker
      v-bind="$attrs" 
      v-on="$listeners"       
      value-type="YYYY-MM-DD" 
      format="DD-MM-YYYY"
      type="date"
      :placeholder="label"      
      style="width: 100% !important;"
    ></date-picker>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
export default {
  components: { DatePicker },
  props: {
    label: String
  },  
};
</script>
